<template>
  <div class="comments-ctn" style="background-color: #fff">
    <p class="section-title">
      评论
      <span class="array-length">({{ comments.length }})</span>
    </p>
    <div class="comment-ctn" v-for="(comment, index) in comments" :key="index">
      <img class="avatar" src="../assets/avatar.png" />
      <div class="comment-right">
        <div class="name-time">
          <p class="username">{{ comment.author_id }}</p>
          <p class="created-at">
            {{ moment(comment.createdAt).format('YYYY-MM-DD') }}
          </p>
        </div>
        <p class="comment-text">{{ comment.comment }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'Comment',
  props: {
    comments: Array,
  },
  methods: {
    moment,
  },
};
</script>

<style scoped>
.comments-ctn {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 0 10px 20px 10px;
  font-family: sans-serif;
  box-sizing: border-box;
  background-color: #f7f7f7;
}

.comment-ctn {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 6px 0;
}

.username-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.avatar {
  width: 35px;
  height: 35px;
  margin-right: 4px;
}

.comment-text {
  margin-top: 16px;
  font-size: 14px;
  color: #333;
  text-align: justify;
}

.username {
  color: #658ec0;
  font-size: 14px;
}

.comment-right {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 6px;
  border-bottom-color: #f5f5f5;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  padding-bottom: 10px;
}

.name-time {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.time-icon:last-of-type {
  margin-left: 10px;
}

.created-at {
  font-size: 12px;
  color: #999;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  padding: 10px 0;
  color: #333;
}

p {
  margin: 0;
  padding: 0;
}
</style>
